import { LoaderCircleIcon } from "lucide-react";

import { cn } from "@/ui/lib/utils";
import {
  SPINNER_DEFAULTS,
  SPINNER_SIZE_CLASS_MAP,
  type TSpinnerProps,
} from "@/ui/components/primitives/Spinner";

export const Spinner = ({
  size = SPINNER_DEFAULTS.size,
  className,
  ...props
}: TSpinnerProps) => (
  <LoaderCircleIcon
    {...props}
    role="status"
    aria-label="Loading"
    data-component="Spinner"
    className={cn(
      "animate-spin",
      SPINNER_SIZE_CLASS_MAP[size],
      className,
    )}
  />
);

Spinner.displayName = "Spinner";
